import api from "./api";

import {
  CHUNK_SIZE_BULK_SERVICE,
  MAX_CHUNK_SIZE_BULK_SERVICE,
  MAX_RETRIES_BULK_SERVICE,
  HEADER_TRANSLITRATE_BULK_SERVICE,
  HEADER_VENDOR_BULK_SERVICE,
  HEADER_BULK_SEARCH_BULK_SERVICE,
  HCP_BULK_SEARCH_BASIC_BULK_SERVICE,
  HCP_BULK_SEARCH_ADVANCE_BULK_SERVICE,
  HCO_BULK_SEARCH_BASIC_BULK_SERVICE,
  HCO_BULK_SEARCH_ADVANCE_BULK_SERVICE,
  BULK_UPLOAD_TEMPLATES,
  BULK_SEARCH_RECORD_LIMIT_UPLOAD_BASIC_BULK_SERVICE,
  BULK_SEARCH_RECORD_LIMIT_UPLOAD_ADVANCE_BULK_SERVICE,
  BULK_UPLOAD_RECORD_LIMIT_UPLOAD_BULK_SERVICE,
  TRANSLITRATION_RECORD_LIMIT_UPLOAD_BULK_SERVICE,
  RECORDS_PER_CHUNK_BULK_SEARCH_ADVANCE_BULK_SERVICE,
  BULK_SEARCH_RECORD_LIMIT_UPLOAD_BASIC_BULK_SERVICE_VENDOR,
} from "../Constant/BulkOpsContant";
const CHUNK_SIZE = CHUNK_SIZE_BULK_SERVICE;
const MAX_CHUNK_SIZE = MAX_CHUNK_SIZE_BULK_SERVICE;
const MAX_RETRIES = MAX_RETRIES_BULK_SERVICE;
const headerTranslitrate = HEADER_TRANSLITRATE_BULK_SERVICE;
const headerVendor = HEADER_VENDOR_BULK_SERVICE;
const headerBulkSearch = HEADER_BULK_SEARCH_BULK_SERVICE;

const hcpBulkSearchBasic = HCP_BULK_SEARCH_BASIC_BULK_SERVICE;
const hcpBulkSearchAdvance = HCP_BULK_SEARCH_ADVANCE_BULK_SERVICE;
const hcoBulkSearchBasic = HCO_BULK_SEARCH_BASIC_BULK_SERVICE;
const hcoBulkSearchAdvance = HCO_BULK_SEARCH_ADVANCE_BULK_SERVICE;

// Picks the template whose columns match the file; otherwise reports the closest one's gaps.
const matchBulkUploadTemplate = (fileHeaders) => {
  const fileSet = new Set(fileHeaders);
  let closest = null;
  for (const template of BULK_UPLOAD_TEMPLATES) {
    const missing = template.headers.filter((h) => !fileSet.has(h));
    const extra = fileHeaders.filter((h) => !template.headers.includes(h));
    if (missing.length === 0 && extra.length === 0) {
      return template;
    }
    if (
      !closest ||
      missing.length + extra.length < closest.missing.length + closest.extra.length
    ) {
      closest = { template, missing, extra };
    }
  }
  const parts = [];
  if (closest.missing.length > 0) {
    parts.push(`Missing columns: ${closest.missing.join(", ")}`);
  }
  if (closest.extra.length > 0) {
    parts.push(`Unexpected columns: ${[...new Set(closest.extra)].join(", ")}`);
  }
  throw new Error(
    `File does not match any of the supported templates. Closest match is "${closest.template.label}". ${parts.join(". ")}`,
  );
};

const readFileAsText = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.onerror = reject;
    reader.readAsText(file);
  });
};

const stripOuterQuotes = (value = "") => {
  const trimmedValue = String(value).trim();
  if (trimmedValue.startsWith('"') && trimmedValue.endsWith('"')) {
    return trimmedValue.slice(1, -1).trim();
  }
  return trimmedValue;
};

const isEffectivelyEmptyCsvRow = (row) => {
  if (row == null) {
    return true;
  }

  const normalizedRow = String(row).replace(/\r/g, "");
  if (normalizedRow.trim() === "") {
    return true;
  }

  const cells = normalizedRow.split(",").map((cell) => stripOuterQuotes(cell));
  return cells.every((cell) => cell === "");
};

export const createRecordAwareChunks = async (
  file,
  uploadType,
  searchFor,
  searchType,
  searchIn,
) => {
  try {
    const csvContent = await readFileAsText(file);
    const lines = csvContent
      .replace(/\r\n/g, "\n")
      .replace(/\r/g, "\n")
      .split("\n");
    if (lines.length === 0) {
      throw new Error("CSV file is empty. Please upload a valid file.");
    }
    const headers = lines[0];
    const fileHeaders = headers.split(",").map((h) => h.trim());
    if (uploadType === "transliteration") {
      var headerOptions = headerTranslitrate;
    } else if (uploadType === "bulkSearch") {
      var headerOptions =
        searchFor === "HCP"
          ? searchType === "basic"
            ? searchIn === "vendor"
              ? headerVendor
              : hcpBulkSearchBasic
            : hcpBulkSearchAdvance
          : searchType === "basic"
            ? searchIn === "vendor"
              ? headerVendor
              : hcoBulkSearchBasic
            : hcoBulkSearchAdvance;
    } else if (uploadType === "bulkupload") {
      var headerOptions = matchBulkUploadTemplate(fileHeaders).headers;
    }
    const hasAllRequiredHeaders = headerOptions.every((option) =>
      fileHeaders.includes(option),
    );
    if (!hasAllRequiredHeaders) {
      throw new Error(
        `CSV file must contain all required headers: ${headerOptions.join(
          ", ",
        )}`,
      );
    }
    const hasDuplicateHeaders =
      new Set(fileHeaders).size !== fileHeaders.length;
    if (hasDuplicateHeaders) {
      throw new Error("CSV file contains duplicate headers");
    }
    const hasExtraHeaders = fileHeaders.some(
      (header) => !headerOptions.includes(header),
    );
    if (hasExtraHeaders) {
      throw new Error(
        `CSV file contains extra headers. Only these are allowed: ${headerOptions.join(
          ", ",
        )}`,
      );
    }
    const dataRows = lines
      .slice(1)
      .map((line) => line.replace(/\r/g, ""))
      .filter((line) => !isEffectivelyEmptyCsvRow(line));
    if (dataRows.length === 0) {
      throw new Error("CSV file contains only headers, no data rows");
    }
    if (
      uploadType === "bulkSearch" &&
      searchType === "advance" &&
      dataRows.length > BULK_SEARCH_RECORD_LIMIT_UPLOAD_ADVANCE_BULK_SERVICE
    ) {
      throw new Error(
        `For advance search, maximum ${BULK_SEARCH_RECORD_LIMIT_UPLOAD_ADVANCE_BULK_SERVICE} records are allowed`,
      );
    }

    if (
      uploadType === "bulkSearch" &&
      searchType === "basic" &&
      dataRows.length > BULK_SEARCH_RECORD_LIMIT_UPLOAD_BASIC_BULK_SERVICE
    ) {
      throw new Error(
        `For basic search, maximum ${BULK_SEARCH_RECORD_LIMIT_UPLOAD_BASIC_BULK_SERVICE} records are allowed`,
      );
    }
    if (
      uploadType === "bulkSearch" &&
      searchType === "basic" &&
      searchIn === "vendor" &&
      dataRows.length >
        BULK_SEARCH_RECORD_LIMIT_UPLOAD_BASIC_BULK_SERVICE_VENDOR
    ) {
      throw new Error(
        `For basic search, maximum ${BULK_SEARCH_RECORD_LIMIT_UPLOAD_BASIC_BULK_SERVICE_VENDOR} records are allowed`,
      );
    }

    if (
      uploadType === "bulkupload" &&
      dataRows.length > BULK_UPLOAD_RECORD_LIMIT_UPLOAD_BULK_SERVICE
    ) {
      throw new Error(
        `For bulk upload, maximum ${BULK_UPLOAD_RECORD_LIMIT_UPLOAD_BULK_SERVICE} records are allowed`,
      );
    }
    if (
      uploadType === "transliteration" &&
      dataRows.length > TRANSLITRATION_RECORD_LIMIT_UPLOAD_BULK_SERVICE
    ) {
      throw new Error(
        `For transliteration, maximum ${TRANSLITRATION_RECORD_LIMIT_UPLOAD_BULK_SERVICE} records are allowed`,
      );
    }
    const chunks = [];
    let currentChunk = [];
    let currentChunkStartIndex = 0;
    const headerSize = new TextEncoder().encode(headers + "\n").length;
    let currentChunkSize = headerSize;

    // For advance search in bulk search, use record-based chunking (100 records per chunk)
    const isAdvanceBulkSearch =
      uploadType === "bulkSearch" && searchType === "advance";
    const RECORDS_PER_CHUNK =
      RECORDS_PER_CHUNK_BULK_SEARCH_ADVANCE_BULK_SERVICE;

    if (isAdvanceBulkSearch) {
      // Record-based chunking for advance search
      for (let i = 0; i < dataRows.length; i += RECORDS_PER_CHUNK) {
        const chunkRows = dataRows.slice(i, i + RECORDS_PER_CHUNK);
        const chunkContent = headers + "\n" + chunkRows.join("\n");
        const chunkBlob = new Blob([chunkContent], { type: "text/csv" });
        const firstRowNo = i + 1;
        const lastRowNo = i + chunkRows.length;
        chunkBlob.firstRowNo = firstRowNo;
        chunkBlob.lastRowNo = lastRowNo;
        chunks.push(chunkBlob);
      }
    } else {
      // Size-based chunking for other cases
      const rowSizes = dataRows.map(
        (row) => new TextEncoder().encode(row + "\n").length,
      );
      for (let i = 0; i < dataRows.length; i++) {
        const row = dataRows[i];
        const rowSize = rowSizes[i];
        const potentialChunkSize = currentChunkSize + rowSize;
        if (potentialChunkSize > CHUNK_SIZE && currentChunk.length > 0) {
          const chunkContent = headers + "\n" + currentChunk.join("\n");
          const chunkBlob = new Blob([chunkContent], { type: "text/csv" });
          const firstRowNo = currentChunkStartIndex + 1;
          const lastRowNo = currentChunkStartIndex + currentChunk.length;
          chunkBlob.firstRowNo = firstRowNo;
          chunkBlob.lastRowNo = lastRowNo;
          chunks.push(chunkBlob);
          currentChunk = [row];
          currentChunkStartIndex = i;
          currentChunkSize = headerSize + rowSize;
        } else {
          currentChunk.push(row);
          currentChunkSize += rowSize;
          if (potentialChunkSize > MAX_CHUNK_SIZE) {
            console.warn(
              `Warning: Chunk ${
                chunks.length + 1
              } exceeds max size but preserving record integrity`,
            );
          }
        }
      }
      if (currentChunk.length > 0) {
        const chunkContent = headers + "\n" + currentChunk.join("\n");
        const chunkBlob = new Blob([chunkContent], { type: "text/csv" });
        const firstRowNo = currentChunkStartIndex + 1;
        const lastRowNo = currentChunkStartIndex + currentChunk.length;
        chunkBlob.firstRowNo = firstRowNo;
        chunkBlob.lastRowNo = lastRowNo;
        chunks.push(chunkBlob);
      }
    }
    return chunks;
  } catch (error) {
    console.log(error);
    console.error("Error creating record-aware chunks:", error);
    throw new Error(`Failed to process CSV file: ${error.message}`);
  }
};
export const uploadChunk = async (
  chunk,
  chunkIndex,
  totalChunks,
  selectedOption,
  selectedFile,
  uniqueID,
  uploadType,
  createdAt,
  searchFor,
  lastRowIndex,
  firstRowIndex,
  searchType,
  selectedCountry,
  canExpeditedFlow,
  retryCount = 0,
) => {
  try {
    // Convert chunk to base64
    const binaryBlob = new Blob([chunk], {
      type: "application/octet-stream",
    });

    // Convert blob to base64
    const base64Data = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result.split(",")[1]; // Remove data:application/octet-stream;base64, prefix
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(binaryBlob);
    });

    // Pre-calculate values to avoid redundant operations
    const chunkSizeMB = (binaryBlob.size / (1024 * 1024)).toFixed(2);
    const exceeds4MB = binaryBlob.size > CHUNK_SIZE;
    // Convert chunkIndex to base64
    const chunkIndexBase64 = btoa(chunkIndex.toString());

    // Calculate record count (excluding header)
    const chunkText = await chunk.text();
    const chunkLines = chunkText
      .replace(/\r\n/g, "\n")
      .replace(/\r/g, "\n")
      .split("\n")
      .filter((line) => !isEffectivelyEmptyCsvRow(line));
    const recordCount = chunkLines.length > 0 ? chunkLines.length - 1 : 0; // Subtract 1 for header

    const formData = new FormData();
    formData.append(
      "fileName",
      `${selectedFile.name
        .split(".")
        .slice(0, -1)
        .join(".")}.${selectedFile.name.split(".").pop()}`,
    );
    formData.append("totalParts", totalChunks);
    formData.append("partLastIndex", lastRowIndex);
    formData.append("partFirstIndex", firstRowIndex);
    // formData.append("partId", crypto.randomUUID());
    formData.append("appId", uploadType);
    formData.append("partNum", chunkIndex); // Send base64 encoded chunkIndex
    formData.append("data", base64Data); // Send as base64 string
    formData.append("fileType", "csv");
    if (uploadType === "BULKUPLOAD") {
      formData.append("customRules", JSON.stringify(selectedOption));
      formData.append("eConsentCountry", selectedCountry);
      formData.append("searchScope", "both");
      formData.append("bulkUploadProcess", "search");
      formData.append("expediteFlow", canExpeditedFlow ? "true" : "false");
    }
    if (uploadType === "BULKSEARCH" || uploadType === "TRANSLITERATION") {
      formData.append("searchType", searchType);
      formData.append("countryNameForVendor", selectedCountry);
    }
    formData.append("partRecordCount", recordCount);
    formData.append("partsUploaded", chunkIndex);
    if (chunkIndex === 0) {
      formData.append("apiType", "FILE");
      if (uploadType === "BULKSEARCH" || uploadType === "TRANSLITERATION") {
        formData.append("searchScope", selectedOption);
        formData.append("entityType", searchFor);
      }
    } else if (chunkIndex < totalChunks - 1) {
      formData.append("apiType", "PART");
      // formData.append("createdAt", createdAt);
      formData.append("uploadId", uniqueID);
    } else {
      formData.append("uploadId", uniqueID);
      // formData.append("createdAt", createdAt);
      formData.append("apiType", "PART_LAST");
    }
    const response = await api.uploadTransliterationChunk(formData);
    if (response.status === 429) {
      throw new Error(
        "Please wait for some time and try again later. If the issue persists, please contact support.",
      );
    }
    return response.data;
  } catch (error) {
    if (retryCount < MAX_RETRIES) {
      const baseDelay = 500;
      const jitter = Math.random() * 200;
      const delay = baseDelay * Math.pow(1.5, retryCount) + jitter;
      await new Promise((resolve) => setTimeout(resolve, delay));
      return uploadChunk(
        chunk,
        chunkIndex,
        totalChunks,
        selectedOption,
        selectedFile,
        uniqueID,
        uploadType,
        createdAt,
        searchFor,
        lastRowIndex,
        firstRowIndex,
        searchType,
        selectedCountry,
        canExpeditedFlow,
        retryCount + 1,
      );
    } else {
      throw new Error(
        `Failed to upload chunk ${chunkIndex + 1} after ${MAX_RETRIES} retries`,
      );
    }
  }
};
